<template>
  <transition name="pa-simple-fade" @enter="handleEnter">
    <div class="pa-tokei-modal-detail" v-if="couldOpenDetail">
      <button class="back-button" @click.prevent="handleBack">
        <font-awesome-icon icon="arrow-left" size="xs" fixed-width />戻る
      </button>
      
      <div class="message-field">
        <p class="date" :class="dateClass">{{infomation.date}}</p>
        <p class="title">{{infomation.title}}</p>
        <div class="body" v-html="infomation.body"></div>

        <template v-if="hasDetailButton">
          <button class="pa-detail-button" @click="handleClickDetailButton">{{detailButton.label}}</button>
        </template>
        
        <button class="back-button back-button-circle" @click.prevent="handleBack">
          <font-awesome-icon icon="arrow-left" size="xs" fixed-width />戻る
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import {GetInfomation} from '@/graphql/queries/Infomation.graphql'

import {MarkAsReadInfomation} from '@/graphql/mutations/Infomation.graphql'

export default {
  props : {
    isOpen : {
      default: false
    }
  },

  data(){
    return {
      dateClass             : [],
      hasDetailButton       : false,
      detailButton          : null,

      selectedInfomationId  : null
    };
  },

  computed : {
    // selectedInfomationId(){
    //   return this.$store.state.paTimesModal.selectedInfomationId;
    // },

    urlQuery(){
      return this.$route.query;
    },
    
    couldOpenDetail(){
      if(
        (typeof this.infomation !== 'undefined') && 
        (this.isOpen === true)
      ){
        return true;
      }else{
        return false;
      }
    },

    isLoadingData(){
      if(typeof this.$apollo.queries.infomation === 'undefined') return false;

      return this.$apollo.queries.infomation.loading;
    }
  },

  apollo : {
    infomation : {
      query: GetInfomation,
      variables(){
        return {
          id: this.selectedInfomationId
        }
      },
      skip(){
        if(this.selectedInfomationId === null){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  watch : {
    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        if( typeof data.infomation_id === 'undefined' ){
          this.selectedInfomationId = null;
        }else{
          this.selectedInfomationId = data.infomation_id;
        }
      },
      immediate: true,
      deep: true
    },

    infomation : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data.characterReaded === true){
          this.dateClass = ['date-readed'];
        }else{
          this.dateClass = [];
        }

        if(data.meta !== null){
          if(
            (typeof data.meta.detailButton !== 'undefined') && 
            (data.meta.detailButton !== null)
          ){
            this.hasDetailButton = true;
            this.detailButton    = data.meta.detailButton;
          }else{
            this.hasDetailButton = false;
            this.detailButton    = null;
          }
        }else{
          this.hasDetailButton = false;
          this.detailButton    = null;
        }
      },
      deep: true,
      immediate: true
    },

    isLoadingData(value){
      this.$store.dispatch({
        type  : 'paTimesModal/updateIsLoadingModal',
        value : value
      });
    }
  },

  methods : {
    executeMarkAsReadInfomation(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : MarkAsReadInfomation,
          variables : {
            infomationId  : this.infomation.id
          },
          update    : (store, {data: {MarkAsReadInfomation}}) => {
            if(MarkAsReadInfomation.status === true){
              store.writeQuery({
                query: GetInfomation,
                variables : {
                  id  : MarkAsReadInfomation.infomation.id
                },
                data : {
                  infomation : MarkAsReadInfomation.infomation
                }
              });
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    handleEnter(){
      this.executeMarkAsReadInfomation();
    },

    handleBack(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      delete newUrlQuery.infomation_id;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    handleCloseModal(){
      this.$emit('requestClose');
    },

    handleClickDetailButton(){
      if(this.hasDetailButton === false) return;
      if(typeof this.detailButton !=='object') return;

      const newUrlQuery = Object.assign({}, this.$route.query);

      if(typeof newUrlQuery.y !== 'undefined'){
        delete newUrlQuery.y;
      }

      if(typeof newUrlQuery.times_modal_open !== 'undefined'){
        delete newUrlQuery.times_modal_open;
      }

      if(typeof newUrlQuery.infomation_id !== 'undefined'){
        delete newUrlQuery.infomation_id;
      }

      let parameter = {};

      if(this.detailButton.parameter !== null){
        parameter = JSON.parse(this.detailButton.parameter);
      }

      if(this.detailButton.query !== null){
        const requestQueries = JSON.parse(this.detailButton.query);

        for(let i in requestQueries){
          newUrlQuery[i] = requestQueries[i];
        }
      }

      this.$router.push({
        name    : this.detailButton.path,
        params  : parameter,
        query   : newUrlQuery
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-tokei-modal-detail{
  position: absolute;
  top:0;
  left:0;
  width:100%;
  z-index:11;
  overflow: hidden;
  
  button.back-button{
    display: block;
    width:100%;
    padding:.32rem 0 .3rem;
    color:#540e23;
    text-align: center;
    background-color:#823051;
    font-size:1rem;
    border:0;

    svg{
      margin-top:-1rem;
      margin-right:2px;
    }

    &:active{
      background-color: #802342;
      color:#3B0918;
    }

    &:focus{
      outline: inherit;
    }

    @media screen and (min-width: $desktop) {
      font-size:1.1rem;
      padding:12px 0 8px;
    }

    &-circle{
      width:auto;
      min-width:60px;
      min-height:48px;
      margin:.8rem 0 1rem;
      padding:.1rem 1.2rem;
      border-radius: 25px;
      line-height: 46px;
      text-indent: -4px;

      &:active{
        background-color: #802342;
        color:#3B0918;
      }
    }
  }

  .message-field{
    width:95%;
    margin:.5rem auto;
    color:#cccccc;

    p.date{
      font-size:.9rem;
      border-radius: 12px;
      text-align: center;
      width:30vw;
      background-color:#6D1B36;

      &-readed{
        color:#BF9DA6;
        background-color:#77314E;
      }
    }

    p.title{
      font-size:1.4rem;
      color:#ceafbd;
      margin:.4rem .2rem 0;
      padding-bottom:.4rem;
      border-bottom:2px solid #823051;
      color:#cccccc;
    }

    div.body{
      overflow-y: scroll;
      padding-top:.5rem;
      color:#b58fa0;
      
      p{
        font-size:1rem;
        margin-bottom:.3rem;
      }
    }

    button.pa-detail-button{
      display: block;
      width:98%;
      margin:.8rem auto 0;
      border-radius: 6px;
      padding:.32rem 0 .3rem;
      color:#fafafa;
      text-align: center;
      background-color:#ac426c;
      font-size:1rem;
      border:0;
    }

    @media screen and (min-width: $desktop) {
      max-width:750px;
      margin:20px auto;

      p.title{
        margin:10px 4px;
        padding-bottom:10px;
      }

      div.body{
        padding-top:0;
        p{
          font-size:1.1rem;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>